module.exports = __webpack_public_path__ + "img/y-231.075fcf92.png";